module.exports = __webpack_public_path__ + "static/media/quit-survey-icon.b9626258.svg";